var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-f_instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f_instagram",
    clipPath: "url(#clip-f_instagram)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1179",
    "data-name": "Gruppe 1179",
    transform: "translate(-1110 -954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M15,30A15,15,0,0,1,4.393,4.393,15,15,0,0,1,25.607,25.607,14.9,14.9,0,0,1,15,30ZM15,6.562c-1.5,0-2.835.023-3.48.06A4.982,4.982,0,0,0,7.985,7.981a4.978,4.978,0,0,0-1.363,3.534c-.08,1.4-.08,5.562,0,6.961a4.959,4.959,0,0,0,1.363,3.535,5,5,0,0,0,3.535,1.363c.649.037,1.983.06,3.481.06s2.831-.023,3.48-.06a4.961,4.961,0,0,0,3.535-1.363,4.992,4.992,0,0,0,1.363-3.535c.08-1.4.08-5.559,0-6.957a4.959,4.959,0,0,0-1.363-3.535A4.992,4.992,0,0,0,18.48,6.622C17.835,6.585,16.5,6.562,15,6.562Zm1.489,15.362c-.317,0-.62,0-.888-.006h-.027c-.212,0-.405,0-.573,0s-.37,0-.588,0c-.263,0-.56.005-.869.005a12.1,12.1,0,0,1-3.516-.349,2.847,2.847,0,0,1-1.6-1.6A15.207,15.207,0,0,1,8.081,15.6v-.012c0-.218,0-.416,0-.587s0-.366,0-.581v-.007a15.353,15.353,0,0,1,.343-4.385,2.848,2.848,0,0,1,1.6-1.6,11.9,11.9,0,0,1,3.487-.349c.3,0,.593,0,.887.006h.029c.211,0,.4,0,.57,0s.37,0,.588,0c.265,0,.561-.005.869-.005a12.1,12.1,0,0,1,3.517.349,2.852,2.852,0,0,1,1.6,1.6,15.184,15.184,0,0,1,.343,4.37c0,.224,0,.428,0,.6s0,.379,0,.6a15.175,15.175,0,0,1-.343,4.37,2.852,2.852,0,0,1-1.6,1.6A11.9,11.9,0,0,1,16.489,21.924ZM15,10.673a4.319,4.319,0,1,0,3.06,1.265A4.3,4.3,0,0,0,15,10.673Zm4.5-1.185A1.009,1.009,0,1,0,20.514,10.5,1.01,1.01,0,0,0,19.5,9.487ZM15,17.811A2.812,2.812,0,1,1,17.814,15,2.815,2.815,0,0,1,15,17.811Z",
    transform: "translate(1111 955)",
    fill: "#383e4e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.19ca6870d04eb0ca2539092ee75eba34.svg";
export { ForwardRef as ReactComponent };